import React, { FC } from "react";

import { BrandTile, Column, DesktopMenuList, Row } from "../../../components";

const DMBrandsLogoFlyout: FC = () => {
  return (
    <Row>
      <Column xs={2}>
        <DesktopMenuList
          titleLink={{ text: "A-Z LIST Of Brands" }}
          linksItems={[{ text: "View all brands" }]}
          disablePointerEffects
        />
      </Column>
      <Column xs={2}>
        <BrandTile type="Nike" />
        <BrandTile type="Reebok" />
      </Column>
      <Column xs={2}>
        <BrandTile type="Adidas" />
        <BrandTile type="Taf" />
      </Column>
      <Column xs={2}>
        <BrandTile type="Asics" />
        <BrandTile type="NewBalance" />
      </Column>
      <Column xs={2}>
        <BrandTile type="Puma" />
        <BrandTile type="Skechers" />
      </Column>
      <Column xs={2}>
        <BrandTile type="Tnf" />
        <BrandTile type="Nakamura" />
      </Column>
    </Row>
  );
};

export default DMBrandsLogoFlyout;
